// extracted by mini-css-extract-plugin
module.exports = {"root":"quickbooks_root__kXHf5","infoBtn":"quickbooks_infoBtn__2YBN1","formBox":"quickbooks_formBox__WMOQ7","formFooter":"quickbooks_formFooter__8kkjY"};